import React, { useEffect, useState } from 'react';
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/pro-duotone-svg-icons';

const DateRangePickerWrapper = styled.div`
  display: inline-block;
  position: relative;
  .DateRangePickerInput {
    background-color: white;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    .DateInput_input:hover {
      color: #989898;
    }
  }

  ${props => props.isOpened && `
    .DateRangePickerInput {
      color: white;
      background-color: #ff2309;
      fill: white;
    }
    .DateInput, .DateInput_input, .DateRangePickerInput_arrow, .DateRangePickerInput_arrow_svg {
      color: inherit;
      background-color: transparent;
      transition: inherit;
      fill: inherit;
    }
    .DateRangePickerInput {
      border-color: #fb1b00;
      transition: inherit;
      .DateInput_input:hover {
        color: #fbd6cd;
      }
    }
  `}
`

const DateRangePickerIconWrapper = styled.div`
  display: block;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
`

export const DateRangeFilterButton = ({onChange, ...props}) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [focusedInput, setFocusedInput] = useState();
  const [isOpened, setIsOpened] = useState(false);

	const { i18n } = useTranslation();
  moment.locale(i18n.language)

  const dateToString = (date) => {
    return date ? date.format('YYYY-MM-DD') : null
  }

  const handleFocusChange = (focusedInput) => {
    if (focusedInput) {
      setIsOpened(true)
    } else {
      setIsOpened(false)
    }
    setFocusedInput(focusedInput)
  }

  useEffect(() => {
    props.startDate && setStartDate(moment(props.startDate, 'YYYY-MM-DD'))
  }, [props.startDate])

  useEffect(() => {
    props.endDate && setEndDate(moment(props.endDate, 'YYYY-MM-DD'))
  }, [props.endDate])

  const onDatesChange = ({startDate, endDate}) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if(startDate && endDate) {
      onChange("startDate", dateToString(startDate))
      onChange("endDate", dateToString(endDate))
    }
  }

  return (<DateRangePickerWrapper isOpened={isOpened}>
    <DateRangePickerIconWrapper>
      <FontAwesomeIcon icon={faCalendarDay}/>
    </DateRangePickerIconWrapper>
    <DateRangePicker
      startDate={startDate}
      startDateId="start-date"
      endDate={endDate}
      endDateId="end-date"
      onDatesChange={onDatesChange}
      isOutsideRange={(date) => date >= (new Date()).setUTCHours(23,59,59,999)}
      focusedInput={focusedInput}
      onFocusChange={handleFocusChange}
      daySize={30}
    />
  </DateRangePickerWrapper>)
}
